import { render } from "./RemoveRowCellRenderer.vue?vue&type=template&id=47b8cb40&scoped=true"
import script from "./RemoveRowCellRenderer.vue?vue&type=script&lang=js"
export * from "./RemoveRowCellRenderer.vue?vue&type=script&lang=js"

import "./RemoveRowCellRenderer.vue?vue&type=style&index=0&id=47b8cb40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b8cb40"]])

export default __exports__